import {
  Button,
  ComponentMultiStyleConfig,
  Flex,
  Textarea,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { ComponentStyleProps } from "../../../../../lib/styles/props/component-style-props";
import { DeleteIconButton } from "../../../../icon-button";
import { useAutoFocus } from "../../../../../hooks/use-auto-focus";

export type CMFormCommentInputProps = {
  placeholder?: string;
  finishButtonLabel: string;
  cancelButtonLabel: string;
  deleteButtonLabel: string;

  /**
   * trueなら、マウント時にフォーカスされる。
   */
  focusOnMount?: boolean;
  /**
   * 最大文字数。
   * 指定しなければ無制限。
   */
  maxLength?: number;

  value: string;

  /**
   * 保存して編集終了したときのコールバック。
   */
  onSave: (value: string) => void;
  /**
   * キャンセルして編集終了したときのコールバック。
   */
  onCancel: () => void;
  /**
   * 削除したときのコールバック。
   */
  onDelete: () => void;
} & ComponentStyleProps;

export const CMFormCommentInput = ({
  placeholder,
  finishButtonLabel,
  cancelButtonLabel,
  deleteButtonLabel,

  focusOnMount = false,
  maxLength,

  value,

  onSave,
  onCancel,
  onDelete,

  sx,
  ...rest
}: CMFormCommentInputProps) => {
  const styles = useMultiStyleConfig("CMFormCommentInputStyles");

  const autoFocusRef = useAutoFocus<HTMLTextAreaElement>(focusOnMount);
  const [currentValue, setCurrentValue] = useState(value);

  return (
    <Flex sx={{ ...styles.container, ...sx }} {...rest}>
      <Textarea
        value={currentValue}
        onChange={(e) => setCurrentValue(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        sx={styles.textarea}
        ref={autoFocusRef}
      />
      <Flex direction="row" wrap="nowrap" sx={styles.controls}>
        <Button
          colorScheme="teal"
          onClick={() => onSave(currentValue)}
          size="sm"
          sx={styles.finishButton}
        >
          {finishButtonLabel}
        </Button>
        <Button
          colorScheme="gray"
          onClick={() => {
            setCurrentValue(value);
            onCancel();
          }}
          size="sm"
          sx={styles.cancelButton}
        >
          {cancelButtonLabel}
        </Button>
        <DeleteIconButton
          tipMessage={deleteButtonLabel}
          ariaLabel={deleteButtonLabel}
          onClick={onDelete}
          sx={styles.deleteIconButton}
        />
      </Flex>
    </Flex>
  );
};

export const CMFormCommentInputStyles: ComponentMultiStyleConfig = {
  parts: [
    "container",
    "userName",
    "textarea",
    "controls",
    "finishButton",
    "cancelButton",
    "deleteIconButton",
  ],
  baseStyle: {
    container: {
      flexFlow: "column nowrap",
    },
    userName: {
      alignSelf: "flex-start",

      h: "24px",
    },
    textarea: {
      mt: "4px",

      fontSize: "sm",
      backgroundColor: "white",
    },
    controls: {
      alignSelf: "stretch",

      mt: "8px",
    },
    finishButton: {},
    cancelButton: {
      ml: "2",
    },
    deleteIconButton: {
      ml: "auto",
    },
  },
};
